"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var react_tracking_1 = require("react-tracking");
var graphql_tag_1 = require("graphql-tag");
var I18n = require("i18n-js");
var elog = require("../../elog");
var lodash_1 = require("lodash");
var constants_1 = require("../constants");
var listings_collection_1 = require("../../components/listings_collection");
var tracker_1 = require("../../tracker");
var core_link_1 = require("../../components/core_link");
var sanitized_render_1 = require("../../components/sanitized_render");
var user_context_provider_1 = require("../../components/user_context_provider");
var COMPONENT_NAME = 'CMSListingsCollection';
function getItemRegion(ownProps) {
    if (ownProps.itemRegion) {
        return ownProps.itemRegion;
    }
    /* If an item region is not specifically set, then default to everywhere.
    For most situations, this is a no-op. But if a sticky seller location exists for the user,
    we cancel it out to display more listings. It also prevents confusion
    since an implicit sticky seller location filter on CMS rows is surprising. */
    return constants_1.EVERYWHERE_CODE;
}
var CMSListingsCollection = /** @class */ (function (_super) {
    tslib_1.__extends(CMSListingsCollection, _super);
    function CMSListingsCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CMSListingsCollection.prototype.componentDidMount = function () {
        if (!this.props.data.loading && this.listings().length) {
            this.props.tracking.trackEvent({
                eventType: tracker_1.VIEW,
                ids: this.listings().map(function (listing) { return listing.id; }),
            });
        }
    };
    CMSListingsCollection.prototype.componentDidUpdate = function (oldProps) {
        if (!this.props.data.loading && this.listings().length && !lodash_1.isEqual(this.props.data, oldProps.data)) {
            this.props.tracking.trackEvent({
                eventType: tracker_1.VIEW,
                ids: this.listings().map(function (listing) { return listing.id; }),
            });
        }
    };
    CMSListingsCollection.prototype.renderCTA = function () {
        if (!this.props.ctaTargetHref) {
            return;
        }
        return (React.createElement(core_link_1.default, { className: this.props.displayAsGrid && 'button button--orange', to: this.props.ctaTargetHref, interactionType: tracker_1.CTA }, this.props.ctaText
            ? this.props.ctaText
            : I18n.t('cms.listingsCollection.seeMore')));
    };
    CMSListingsCollection.prototype.renderTitle = function () {
        return (React.createElement(sanitized_render_1.default, { html: this.props.titleHtml || this.props.title }));
    };
    CMSListingsCollection.prototype.listings = function () {
        return lodash_1.get(this.props, 'data.listingsSearch.listings', []);
    };
    CMSListingsCollection.prototype.render = function () {
        try {
            if (!this.props.data.loading && !this.listings().length) {
                return null;
            }
            return (React.createElement(listings_collection_1.default, { callToAction: this.renderCTA(), componentName: this.props.componentName, displayAsGrid: this.props.displayAsGrid, largeTiles: this.props.largeTiles, listings: this.listings(), loading: this.props.data.loading, maxCount: this.props.maxCount, title: this.renderTitle(), jumplinkSlug: this.props.jumplinkSlug, subtitle: this.props.subtitle, ledeHtml: this.props.ledeHtml }));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    CMSListingsCollection.defaultProps = {
        componentName: COMPONENT_NAME,
    };
    CMSListingsCollection = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: props.componentName,
                type: tracker_1.LISTING_TYPE,
                context: {
                    title: props.title,
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                    maxCount: props.maxCount,
                    saleCuratedSetId: props.saleCuratedSetId,
                    saleSlug: props.saleSlug,
                    brandUuids: props.brandUuids,
                    categoryUuids: props.categoryUuids,
                    conditionSlugs: props.conditionSlugs,
                    currency: props.currency,
                    query: props.query,
                    priceMax: props.priceMax,
                    priceMin: props.priceMin,
                    sort: props.sort,
                    yearMax: props.yearMax,
                    yearMin: props.yearMin,
                    holidaySale: props.holidaySale,
                    onSale: props.onSale,
                    freeShipping: props.freeShipping,
                    freeExpeditedShipping: props.freeExpeditedShipping,
                    handmade: props.handmade,
                    acceptsOffers: props.acceptsOffers,
                    acceptsGiftCards: props.acceptsGiftCards,
                    preferredSeller: props.preferredSeller,
                    acceptsPaymentPlans: props.acceptsPaymentPlans,
                    curatedSetId: props.curatedSetId,
                    shopSlugs: props.shopSlugs,
                    itemRegion: props.itemRegion,
                },
            };
        })
    ], CMSListingsCollection);
    return CMSListingsCollection;
}(React.Component));
exports.CMSListingsCollection = CMSListingsCollection;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Commons_Cms_ListingsCollection(\n      $shippingRegionCodes: [String]\n      $brandUuids: [String]\n      $categoryUuids: [String]\n      $conditionSlugs: [String]\n      $listingIds: [String]\n      $curatedSetId: String\n      $currency: String\n      $limit: Int\n      $priceMax: String\n      $priceMin: String\n      $sort: reverb_search_ListingsSearchRequest_Sort\n      $onSale: Boolean\n      $freeShipping: Boolean\n      $freeExpeditedShipping: Boolean\n      $handmade: Boolean\n      $acceptsOffers: Boolean\n      $acceptsGiftCards: Boolean\n      $preferredSeller: Boolean\n      $acceptsPaymentPlans: Boolean\n      $saleCuratedSetId: String\n      $saleSlugs: [String]\n      $query: String\n      $yearMax: String\n      $yearMin: String\n      $holidaySale: Boolean\n      $shopSlugs: [String]\n      $itemRegion: String\n      $loggedOut: Boolean!\n    ) {\n      listingsSearch(\n        input: {\n          shippingRegionCodes: $shippingRegionCodes\n          brandUuids: $brandUuids\n          categoryUuids: $categoryUuids\n          curatedSetId: $curatedSetId\n          conditionSlugs: $conditionSlugs\n          currency: $currency\n          limit: $limit\n          priceMax: $priceMax\n          priceMin: $priceMin\n          sort: $sort\n          onSale: $onSale\n          freeShipping: $freeShipping\n          freeExpeditedShipping: $freeExpeditedShipping\n          handmade: $handmade\n          acceptsOffers: $acceptsOffers\n          acceptsGiftCards: $acceptsGiftCards\n          preferredSeller: $preferredSeller\n          acceptsPaymentPlans: $acceptsPaymentPlans\n          saleCuratedSetId: $saleCuratedSetId\n          saleSlugs: $saleSlugs\n          query: $query\n          yearMax: $yearMax\n          yearMin: $yearMin\n          statuses: [\"live\"]\n          holidaySale: $holidaySale\n          shopSlugs: $shopSlugs\n          itemRegion: $itemRegion\n          ids: $listingIds\n        }\n      ) {\n        listings {\n          ... ListingsCollection\n          ... LoggedInFields @skip(if: $loggedOut)\n        }\n      }\n    }\n    ", "\n    ", "\n  "], ["\n    query Commons_Cms_ListingsCollection(\n      $shippingRegionCodes: [String]\n      $brandUuids: [String]\n      $categoryUuids: [String]\n      $conditionSlugs: [String]\n      $listingIds: [String]\n      $curatedSetId: String\n      $currency: String\n      $limit: Int\n      $priceMax: String\n      $priceMin: String\n      $sort: reverb_search_ListingsSearchRequest_Sort\n      $onSale: Boolean\n      $freeShipping: Boolean\n      $freeExpeditedShipping: Boolean\n      $handmade: Boolean\n      $acceptsOffers: Boolean\n      $acceptsGiftCards: Boolean\n      $preferredSeller: Boolean\n      $acceptsPaymentPlans: Boolean\n      $saleCuratedSetId: String\n      $saleSlugs: [String]\n      $query: String\n      $yearMax: String\n      $yearMin: String\n      $holidaySale: Boolean\n      $shopSlugs: [String]\n      $itemRegion: String\n      $loggedOut: Boolean!\n    ) {\n      listingsSearch(\n        input: {\n          shippingRegionCodes: $shippingRegionCodes\n          brandUuids: $brandUuids\n          categoryUuids: $categoryUuids\n          curatedSetId: $curatedSetId\n          conditionSlugs: $conditionSlugs\n          currency: $currency\n          limit: $limit\n          priceMax: $priceMax\n          priceMin: $priceMin\n          sort: $sort\n          onSale: $onSale\n          freeShipping: $freeShipping\n          freeExpeditedShipping: $freeExpeditedShipping\n          handmade: $handmade\n          acceptsOffers: $acceptsOffers\n          acceptsGiftCards: $acceptsGiftCards\n          preferredSeller: $preferredSeller\n          acceptsPaymentPlans: $acceptsPaymentPlans\n          saleCuratedSetId: $saleCuratedSetId\n          saleSlugs: $saleSlugs\n          query: $query\n          yearMax: $yearMax\n          yearMin: $yearMin\n          statuses: [\"live\"]\n          holidaySale: $holidaySale\n          shopSlugs: $shopSlugs\n          itemRegion: $itemRegion\n          ids: $listingIds\n        }\n      ) {\n        listings {\n          ... ListingsCollection\n          ... LoggedInFields @skip(if: $loggedOut)\n        }\n      }\n    }\n    ", "\n    ", "\n  "])), listings_collection_1.default.fragments.listing, listings_collection_1.default.fragments.loggedInFields), {
    options: function (ownProps) { return ({
        ssr: ownProps.ssr,
        variables: {
            shippingRegionCodes: [ownProps.userShippingRegion || lodash_1.get(ownProps.user, 'shippingRegionCode')],
            brandUuids: ownProps.brandUuids,
            categoryUuids: ownProps.categoryUuids,
            conditionSlugs: ownProps.conditionSlugs,
            listingIds: (ownProps.listings || []).map(function (l) { return l.id; }),
            curatedSetId: ownProps.curatedSetId,
            onSale: ownProps.onSale,
            freeShipping: ownProps.freeShipping,
            freeExpeditedShipping: ownProps.freeExpeditedShipping,
            handmade: ownProps.handmade,
            acceptsOffers: ownProps.acceptsOffers,
            acceptsGiftCards: ownProps.acceptsGiftCards,
            preferredSeller: ownProps.preferredSeller,
            acceptsPaymentPlans: ownProps.acceptsPaymentPlans,
            saleCuratedSetId: ownProps.saleCuratedSetId,
            saleSlugs: ownProps.saleSlug && [ownProps.saleSlug],
            currency: ownProps.currency,
            limit: ownProps.maxCount,
            priceMax: ownProps.priceMax,
            priceMin: ownProps.priceMin,
            sort: ownProps.sort,
            yearMax: ownProps.yearMax,
            yearMin: ownProps.yearMin,
            query: ownProps.query,
            holidaySale: ownProps.holidaySale,
            shopSlugs: ownProps.shopSlugs,
            itemRegion: getItemRegion(ownProps),
            loggedOut: !!lodash_1.get(ownProps.user, 'loggedOut'),
        },
    }); },
});
exports.default = user_context_provider_1.withUserContext(connect(CMSListingsCollection));
var templateObject_1;
//# sourceMappingURL=cms_listings_collection.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/cms_listings_collection.js
// module id = q9AZ
// module chunks = 0 2 6 8 20